import axios from "axios";
import store from "@/store";

const pendingRequests = new Set();

let timeout;
const serverBusyTimer = 10000; // 10 seconds before slow-network message

const instance2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem("token_live")}`;
      },
    },
  },
});

const refresh2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem("refresh_token_live")}`;
      },
    },
  },
});

const retry2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem("token_live")}`;
      },
    },
  },
});

function getNewToken2() {
  return new Promise((resolve, reject) => {
    refresh2
      .post("/api/refresh")
      .then((response) => {
        localStorage.setItem("token_live", response.data.token);
        localStorage.setItem("refresh_token_live", response.data.refresh_token);

        resolve(response.data.token);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// Function to notify that the server is busy
const notifyServerIsBusy = () => {
  store.dispatch("change_server_busy_state", true);
  // Show a message to the user in the UI indicating that the server is busy
};

// interceptors to manipulate the global behavior of axios
instance2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token_live");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Clear the previous timeout (if any)
    clearTimeout(timeout);
    // Check if no_busy_msg is not true in the config
    if (!config.disable_busy_message) {
      // Set a new timeout for 5 seconds
      timeout = setTimeout(() => {
        notifyServerIsBusy();
      }, serverBusyTimer);
    }
    pendingRequests.add(config.url);
    return config;
  },
  (error) => Promise.reject(error)
);

instance2.interceptors.response.use(
  function (response) {
    clearTimeout(timeout);
    pendingRequests.delete(response.config.url);
    return response;
  },
  function (error) {
    clearTimeout(timeout);
    pendingRequests.delete(error.config.url);
    if (error.response.status !== 401) {
      return Promise.reject(error);
    }
    // Logout user if token refresh didn't work or user is disabled
    else if (
      error.config.url == "/api/refresh" ||
      error.response.message == "Account is disabled."
    ) {
      return Promise.reject(error);
    } else {
      // #get new token
      // Try request again with new token
      return getNewToken2()
        .then((token) => {
          // New request with new token
          const config = error.config;
          config.headers["Authorization"] = `Bearer ` + token;

          return new Promise((resolve, reject) => {
            retry2
              .request(config)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    }
  }
);

function isRequestPending(url) {
  return pendingRequests.has(url);
}

export { instance2, isRequestPending };
